/**
 * 技能语音描述
 * */
import React, { PureComponent } from 'react';
import Util from '../../../script/util';
import { _dssp_send_click } from '../../../store/Action';
import './SkillAudio.scss';

class SkillAudio extends PureComponent {
  state = {
    playId: null, // 当前播放的音频id
    playSrc: null, // 当前播放的音频地址
  };

  //音频播放
  playAudio = (e, item) => {
    const { selCat } = this.props;
    const { playId } = this.state;
    if (!item) {
      item = selCat;
    }
    if (playId === item.uid) {
      this.audioEnded();
    } else {
      let src = null;
      if (item.voiceUrl && item.voiceUrl != '' && item.voiceUrl != undefined) {
        src = Util.transImgUrl(item.voiceUrl);
      }
      this.setState({ playId: item.uid, playSrc: src }, () => {
        if (this.state.playSrc && this.vadioElement) {
          this.vadioElement
            .play()
            .then(() => {
              // console.info("play success");
            })
            .catch((e) => {
              this.audioEnded();
            });
          _dssp_send_click(69, {
            dsid: item.uid,
            categoryId: item.categoryId,
            online: item.ifOnline,
          });
        }
      });
    }
    e && e.stopPropagation();
  };
  // 音频停止
  audioEnded = () => {
    this.setState({ playId: null, playSrc: null }, () => {
      this.vadioElement && this.vadioElement.pause();
    });
  };

  // 音频播放失败
  audioError = (e) => {
    console.log('---audioError---', e);
  };

  render() {
    const { selCat } = this.props;
    const { playId, playSrc } = this.state;
    return (
      <>
        <span
          className={Util.classNames('skill-category-sound', {
            playing: playId,
          })}
          onClick={(e) => this.playAudio(e, selCat)}
        >
          <label className="time">
            {selCat.voiceLength > 30 ? 30 : selCat.voiceLength}s
          </label>
        </span>

        <audio
          style={{ display: 'none' }}
          src={playSrc}
          onEnded={this.audioEnded}
          onError={this.audioError}
          ref={(el) => (this.vadioElement = el)}
        />
      </>
    );
  }
}

export default SkillAudio;
